import axios from '../utils/axios';

export default function fetchRecruiterList(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/recruiters/search', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
